export const containerWidth = window.innerWidth;
export const containerHeight = window.innerHeight;
export const DocumentHeightTotalResponsive = (numPages: number) => {
  if (containerWidth < 375) {
    return numPages * 400.72;
  } else if (containerWidth >= 375 && containerWidth <= 425) {
    return numPages * 465.35;
  } else if (containerWidth >= 426 && containerWidth <= 767) {
    return numPages * 542.91;
  } else if (containerWidth >= 768 && containerWidth <= 1024) {
    return numPages * 973.1870967741935;
  } else {
    return numPages * 1357;
  }
};
const DocumentWidthResponsive = () => {
  if (containerWidth < 375) {
    return 284;
  } else if (containerWidth >= 375 && containerWidth <= 425) {
    return 330;
  } else if (containerWidth >= 426 && containerWidth <= 767) {
    return 384;
  } else if (containerWidth >= 768 && containerWidth <= 1024) {
    return 688;
  } else {
    return 960;
  }
};
const DocumentHeightResponsive = () => {
  if (containerWidth < 375) {
    return 401.7225806451613;
  } else if (containerWidth >= 375 && containerWidth <= 425) {
    return 466.7903225806452;
  } else if (containerWidth >= 426 && containerWidth <= 767) {
    return 542.91;
  } else if (containerWidth >= 768 && containerWidth <= 1024) {
    return 973.1870967741935;
  } else {
    return 1357;
  }
};

const SignReactWidthResponsive = () => {
  if (containerWidth < 375) {
    return 71.03;
  } else if (containerWidth >= 375 && containerWidth <= 425) {
    return 82.62;
  } else if (containerWidth >= 426 && containerWidth <= 767) {
    return 95.99;
  } else if (containerWidth >= 768 && containerWidth <= 1024) {
    return 172.22;
  } else {
    return 240;
  }
};
const SignReactHeightResponsive = () => {
  if (containerWidth < 375) {
    return 14.8;
  } else if (containerWidth >= 375 && containerWidth <= 425) {
    return 17.18;
  } else if (containerWidth >= 426 && containerWidth <= 767) {
    return 19.99;
  } else if (containerWidth >= 768 && containerWidth <= 1024) {
    return 35.88;
  } else {
    return 50;
  }
};
const TextReactHeightResponsive = () => {
  if (containerWidth < 375) {
    return 17.75 * 0.7;
  } else if (containerWidth >= 375 && containerWidth <= 425) {
    return 20.63 * 0.7;
  } else if (containerWidth >= 426 && containerWidth <= 767) {
    return 24.01 * 0.7;
  } else if (containerWidth >= 768 && containerWidth <= 1024) {
    return 43.05 * 0.7;
  } else {
    return 60 * 0.7;
  }
};

export const documentWidth = DocumentWidthResponsive();
export const documentHeight = DocumentHeightResponsive();
export const signReactWidth = SignReactWidthResponsive();
export const signReactHeight = SignReactHeightResponsive();
export const textReactHeight = TextReactHeightResponsive();
